export default "__VITE_ASSET__CoBpH2bj__"